module.exports = __webpack_public_path__ + "static/blog45-f258df3a4f53a83c6fedcb875e36b10b.png";